import axios from './index';

/**
 * APIs
 */
// captcha
export const captcha = () => {
    return axios<ResType<CaptchaResult>>('/v1/auth/captcha', {
        method: 'get',
    });
};

// login
export const login = (data: LoginData) => {
    return axios<ResType<LoginResult>>('/v1/auth/login', {
        data,
        method: 'post',
    });
};

// logout
export const logout = () => {
    return axios<ResType<Omit<LoginResult, 'token' | 'user'> & User>>('/v1/auth/logout', {
        method: 'post',
    });
};

// me
export const me = () => {
    return axios<ResType<Omit<LoginResult, 'token' | 'user'> & User>>('/v1/me', {
        method: 'get',
    });
};

/**
 * Types
 */
import type { ResType } from '@/typings/common';
import type { Role } from '@/typings/role';
import type { User } from '@/typings/user';

// captcha
export type CaptchaResult = {
    captcha: string;
    captcha_key: string;
};

// login
export type LoginData = {
    account: string;
    captcha: string;
    captcha_key: string;
    password: string;
};

export type LoginResult = {
    permissions: string[];
    roles: Role[];
    token: string;
    user: User;
};
